import { createValidator } from "../../utils/validation";
import { propertyInfoSchema } from "../validationRules/propertyInfoForm";

export const useValidatePropertyInfo = () => {

    const validatePropertyInfo = (formData) => createValidator(propertyInfoSchema)(formData);

    return { validatePropertyInfo };

};